import createApi from 'api/createApi';
import qs from 'query-string';

export const tags = {
	operatorInfo: 'mw/personal-cabinet/operator-info',
	profile: 'mw/personal-cabinet/profile',
	avatar: 'mw/personal-cabinet/avatar',
	appealsStatExtended: 'mw/personal-cabinet/appeal-stat-extended',
	chart: 'mw/personal-cabinet/chart',
	knowledgebaseUpdate: 'mw/personal-cabinet/knowledgebase-update',
	statusTimes: 'mw/personal-cabinet/status-times',
	notifications: 'mw/personal-cabinet/notifications',
	notificationsCount: 'mw/personal-cabinet/notifications-count',
	period: 'mw/personal-cabinet/period',
	kpi: 'mw/personal-cabinet/kpi',
	recentCalls: 'mw/personal-cabinet/recent-calls',
	goals: 'mw/personal-cabinet/goals',
};

export const personApi = createApi({
	reducerPath: 'mw/personCabinetApi',

	endpoints: (builder) => ({
		profile: builder.query({
			query: () => ({
				method: 'GET',
				url: '/mw/personal-cabinet/profile',
			}),
			providesTags: [tags.profile],
		}),
		updateProfile: builder.mutation({
			query: (body) => ({
				method: 'PUT',
				url: '/mw/personal-cabinet/profile',
				body,
				jsonType: true,
			}),
			invalidatesTags: [tags.profile, tags.operatorInfo],
		}),
		saveAvatar: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/personal-cabinet/avatar',
				body,
				jsonType: true,
			}),
			invalidatesTags: [tags.profile, tags.operatorInfo, tags.avatar],
		}),
		operatorInfo: builder.query({
			query: (body) => ({
				method: 'POST',
				url: '/mw/personal-cabinet/operator-info',
				body,
			}),
			providesTags: [tags.operatorInfo],
		}),
		appealsStatExtended: builder.query({
			query: (body) => ({
				method: 'POST',
				url: '/mw/personal-cabinet/appeals-stat-extended',
				body,
			}),
			providesTags: [tags.operatorInfo],
		}),
		chart: builder.query({
			query: (body) => ({
				method: 'POST',
				url: '/mw/personal-cabinet/chart',
				body,
			}),
			providesTags: [tags.chart],
		}),
		knowledgebaseUpdate: builder.query({
			query: () => ({
				method: 'GET',
				url: '/mw/personal-cabinet/knowledgebase-update',
			}),
			providesTags: [tags.knowledgebaseUpdate],
		}),
		statusTimes: builder.query({
			query: (body) => ({
				method: 'POST',
				url: '/mw/personal-cabinet/operator-status-time',
				body,
			}),
			providesTags: [tags.statusTimes],
		}),
		notifications: builder.query({
			query: ({ status, page, limit, includeExpired, readDays, order } = {}) => ({
				method: 'GET',
				url: `/mw/personal-cabinet/system-notifications?${qs.stringify({
					status,
					page,
					limit,
					include_expired: includeExpired ? 1 : undefined,
					read_days: readDays,
					order,
				})}`,
			}),
			providesTags: [tags.notifications],
		}),
		notificationsUnreadCount: builder.query({
			query: () => ({
				method: 'GET',
				url: '/mw/personal-cabinet/system-notifications/unread-count',
			}),
			providesTags: [tags.notificationsCount],
		}),
		notificationRead: builder.mutation({
			query: ({ id } = {}) => ({
				method: 'POST',
				url: `/mw/personal-cabinet/system-notifications/${id}/read`,
			}),
			invalidatesTags: [tags.notifications, tags.notificationsCount],
		}),
		notificationAck: builder.mutation({
			query: ({ id } = {}) => ({
				method: 'POST',
				url: `/mw/personal-cabinet/system-notifications/${id}/ack`,
			}),
			invalidatesTags: [tags.notifications, tags.notificationsCount],
		}),
		notificationReadAll: builder.mutation({
			query: () => ({
				method: 'POST',
				url: '/mw/personal-cabinet/system-notifications/read-all',
			}),
			invalidatesTags: [tags.notifications, tags.notificationsCount],
		}),
		period: builder.query({
			query: () => ({
				method: 'GET',
				url: '/mw/personal-cabinet/period',
			}),
			providesTags: [tags.period],
		}),
		kpi: builder.query({
			query: (body) => ({
				method: 'POST',
				url: '/mw/personal-cabinet/kpi',
				body,
			}),
			providesTags: [tags.kpi],
		}),
		recentCalls: builder.query({
			query: (body) => ({
				method: 'POST',
				url: '/mw/personal-cabinet/recent-calls',
				body,
			}),
			providesTags: [tags.recentCalls],
		}),
		goals: builder.query({
			query: (body) => ({
				method: 'POST',
				url: '/mw/personal-cabinet/goals',
				body,
			}),
			providesTags: [tags.goals],
		}),
	}),
});

export const {
	profile,
	updateProfile,
	saveAvatar,
	operatorInfo,
	appealsStatExtended,
	chart,
	knowledgebaseUpdate,
	statusTimes,
	notifications,
	notificationsUnreadCount,
	notificationRead,
	notificationAck,
	notificationReadAll,
	period,
	kpi,
	recentCalls,
	goals,
} = personApi.endpoints;

export default personApi;
